import { GridOptions } from 'ag-grid-enterprise'
import { AgCustomHeader } from 'components/AgGrid'
import { CustomVanillaDateFilterRenderer } from 'components/AgGrid/components/CustomVanillaDateFilterRenderer'

export const frameworkComponents = {
  AgCustomHeader,
  customDateFilter: CustomVanillaDateFilterRenderer,
}

export const approvalsTableOptions: Partial<GridOptions> = {
  rowHeight: 32,
  headerHeight: 36,
  suppressContextMenu: true,
  preventDefaultOnContextMenu: true,
  rowSelection: 'single',
  reactiveCustomComponents: false,
}
